import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/Navbar/Navbar';
import Footer from '../../../../components/Footer/Footer';
import '../../../../styles/Events.css';
import '../../../../styles/Pages.css';

const API = `${process.env.REACT_APP_API_URL}/api`;

function PollResults() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const token = localStorage.getItem('token');

    useEffect(() => {
        
        window.scrollTo(0, 0);
        
    const headers = { Authorization: `Bearer ${token}` };
        fetch(`${API}/admin/polls/${id}/results`, { headers })
            .then(r => r.json())
            .then(d => {
                if (d.success) setData(d);
                else setError(d.message);
            })
            .catch(() => setError('Failed to load results.'))
            .finally(() => setLoading(false));
    }, [id, token]);

    if (loading) return (
        <div className="page-wrapper"><Navbar />
            <div className="events-loading"><div className="events-spinner" /><p>Loading results…</p></div>
            <Footer />
        </div>
    );
    if (error) return (
        <div className="page-wrapper"><Navbar />
            <div className="page-content"><div className="events-error">{error}</div></div>
            <Footer />
        </div>
    );

    const { poll, totalVotes } = data;
    const sortedOptions = [...poll.options]
        .map((o, i) => ({ ...o, idx: i }))
        .sort((a, b) => b.votes - a.votes);
    const winner = sortedOptions[0];

    const now = new Date();
    const isOpen = poll.isActive && new Date(poll.endTime) > now;

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <h1>📊 {poll.title} — Results</h1>
                <p>{poll.category} &nbsp;|&nbsp; {totalVotes} total votes</p>
            </div>
            <div className="page-content">

                {/* Status */}
                <div className={`poll-status-bar ${isOpen ? 'open' : 'closed'}`}>
                    {isOpen
                        ? `🟢 Poll is still LIVE — results are updating in real time.`
                        : `🔴 Poll ended on ${new Date(poll.endTime).toLocaleString('en-IN')}`}
                </div>

                {/* Winner card */}
                {totalVotes > 0 && (
                    <div className="results-winner-card">
                        <div className="winner-trophy">🏆</div>
                        <div className="winner-label">Current Leader</div>
                        <div className="winner-name">{winner.label}</div>
                        <div className="winner-votes">{winner.votes} vote{winner.votes !== 1 ? 's' : ''}</div>
                        <div className="winner-pct">
                            {totalVotes > 0 ? `${Math.round((winner.votes / totalVotes) * 100)}%` : ''}
                        </div>
                    </div>
                )}

                {/* Results bar chart */}
                <div className="info-card">
                    <h2>All Results ({totalVotes} votes)</h2>
                    {totalVotes === 0 && <p style={{ color: '#888' }}>No votes recorded yet.</p>}
                    <div className="results-bars">
                        {sortedOptions.map((opt, rank) => {
                            const pct = totalVotes > 0 ? Math.round((opt.votes / totalVotes) * 100) : 0;
                            return (
                                <div key={opt.idx} className="result-bar-row">
                                    <div className="result-rank">#{rank + 1}</div>
                                    <div className="result-name">{opt.label}</div>
                                    <div className="result-bar-wrap">
                                        <div
                                            className={`result-bar-fill ${rank === 0 && opt.votes > 0 ? 'winner-bar' : ''}`}
                                            style={{ width: `${pct}%` }}
                                        />
                                    </div>
                                    <div className="result-votes">
                                        <strong>{opt.votes}</strong> <span>({pct}%)</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Poll metadata */}
                <div className="info-card results-meta-card">
                    <h2>Poll Details</h2>
                    <table className="data-table">
                        <tbody>
                            <tr><td><strong>Title</strong></td><td>{poll.title}</td></tr>
                            <tr><td><strong>Category</strong></td><td>{poll.category}</td></tr>
                            <tr><td><strong>Status</strong></td><td>{poll.isActive ? (isOpen ? '🟢 Live' : '🔴 Ended') : '⚪ Inactive'}</td></tr>
                            <tr><td><strong>Start Time</strong></td><td>{new Date(poll.startTime).toLocaleString('en-IN')}</td></tr>
                            <tr><td><strong>End Time</strong></td><td>{new Date(poll.endTime).toLocaleString('en-IN')}</td></tr>
                            <tr><td><strong>Total Candidates</strong></td><td>{poll.options.length}</td></tr>
                            <tr><td><strong>Total Votes</strong></td><td>{totalVotes}</td></tr>
                        </tbody>
                    </table>
                </div>

                <button className="poll-back-btn" onClick={() => navigate('/admin/polls')}>
                    ← Back to Poll Management
                </button>
            </div>
            <Footer />
        </div>
    );
}

export default PollResults;
